import { GrowpIcon } from 'packages/components/GrowpIcon'
import { PermEnum } from 'packages/sdks-next/growp'

import { MenuItemUnion } from 'packages/web-layout/types'

/**
 * 左侧菜单定义
 *
 * @returns 菜单定义对象
 */
export const useActivitiesMenu: () => MenuItemUnion[] = () => {
  return [
    {
      path: '/admin/activities',
      label: (
        <GrowpIcon
          name="Activity"
          text="活动管理"
          size={14}
          textMarginLeft={16}
        />
      ),
      labelText: '活动管理',
      height: 40,
      perm: PermEnum.Activity,
    },
  ]
}
